module.exports = __webpack_public_path__ + "img/ninja3.8e1f7693.png";